import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

const BICYCLE_COVERAGE_FIELDS = [
  {
    name: 'electricBicycleValue', key: 'ELECTRIC_BICYCLE_VALUE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  {
    name: 'make', key: 'MAKE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  {
    name: 'frameNumber', key: 'FRAME_NUMBER', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  {
    name: 'bikeType', key: 'BIKE_TYPE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.BIKE_TYPE.E_BIKE', value: 'E_BIKE' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.BIKE_TYPE.BIKE', value: 'BIKE' },
      ]
    }
  },
];

export const CONTENTS = {
  nickname: 'PRODUCTS.CONTENTS.shortname',
  LIST_OF_OBJECTS: ['bicycleCoverages'],
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: '7500' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: '15000' }
        ]
      }
    },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isStormBicycleCoverageCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.NOT_RENTED', value: 'NO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.PARTIALLY_RENTED', value: 'PARTIAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.RENTED', value: 'YES' }
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.LOCAL_NOTIFICATION',
            value: 'LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.SECURITY_COMPANY_NOTIFICATION',
            value: 'SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITHOUT_NOTIFICATION',
            value: 'WITHOUT_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITH_NOTIFICATION',
            value: 'WITH_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseNumberOfResidents', key: 'HOUSE_NUMBER_OF_RESIDENTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.2_TO_5', value: '2_TO_5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.6_OR_MORE', value: '6_OR_MORE' }
        ]
      }
    },
    {
      name: 'contentsType', key: 'CONTENTS_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.PRIVATE_CONTENTS_AND_MOVABLES',
            value: 'PRIVATE_CONTENTS_AND_MOVABLES'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.BUSINESS_CONTENTS_AND_MOVABLES',
            value: 'BUSINESS_CONTENTS_AND_MOVABLES'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.GARAGE_OUTBUILDING_CONTENTS',
            value: 'GARAGE_OUTBUILDING_CONTENTS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.OWN_FITTINGS',
            value: 'OWN_FITTINGS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.STORED_CONTENTS',
            value: 'STORED_CONTENTS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.FARM_MOVABLES_AND_DISCONTINUED_FARM',
            value: 'FARM_MOVABLES_AND_DISCONTINUED_FARM'
          },
        ]
      }
    },
    {
      name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_HOUSE', value: 'INNBO_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_CABIN', value: 'INNBO_CABIN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_APARTMENT', value: 'INNBO_APARTMENT' },
        ]
      }
    },
    {
      name: 'bicycleCoverages', key: 'BICYCLE_COVERAGES', group: 'INSURANCE_INFO',
      values: BICYCLE_COVERAGE_FIELDS.map(field => ({
        ...field,
        validator: field.validator ? [...field.validator] : field.validator,
        settings: field.settings ? { ...field.settings, list: [...field.settings.list] } : field.settings
      }))
    },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseElectricalSystemRenovationYear', key: 'HOUSE_ELECTRICAL_SYSTEM_RENOVATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
  ],
  icon: 'contents'
};
